import { ApplicationConfig, ErrorHandler, importProvidersFrom } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideHttpClient, withInterceptors } from '@angular/common/http';

import { rootRouterConfig } from './app.routing';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { provideTranslateService } from '@ngx-translate/core';
import { provideOAuthClient } from 'angular-oauth2-oidc';

import { Client as StudentClient, API_BASE_URL } from './api/client-student.service';
import { environment } from '../environments/environment';
import { UserService } from './services/user.service';
import { StudentService } from './services/student.service';
import { AuthenticationService } from './services/student-authentication.service';
import { AuthGuard } from './services/auth/student-auth.guard';
import { LogoutService } from 'app/shared/services/logout.service';
import { BaseConfiguration, ClientSettings, APP_CONFIG } from './api/base-configuration.service';
import { CacheService } from './services/cache.service';
import { ErrorHandlerService } from '../../../../src/app/shared/services/error-handler.service';
import { errorInterceptor } from './interceptors/error-interceptor';
import { correlationInterceptor } from '../../../../src/app/shared/interceptors/correlation-interceptor';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { provideDateFnsAdapter } from '@angular/material-date-fns-adapter';
import { enAU } from 'date-fns/locale';

export const appConfig: ApplicationConfig = {
    providers: [
        importProvidersFrom(MatSnackBarModule),
        provideRouter(rootRouterConfig),
        provideAnimations(),
        provideHttpClient(withInterceptors([errorInterceptor, correlationInterceptor])),
        provideTranslateService(),
        provideOAuthClient({
            resourceServer: {
                allowedUrls: ['http://localhost', 'https://qtac'],
                sendAccessToken: true,
            },
        }),
        ...provideTranslateHttpLoader(),
        provideDateFnsAdapter(),
        UserService,
        AuthGuard,
        AuthenticationService,
        StudentService,
        StudentClient,
        BaseConfiguration,
        CacheService,
        { provide: APP_CONFIG, useValue: (window as any).c as ClientSettings },
        { provide: API_BASE_URL, useValue: environment.apiURL },
        { provide: LogoutService, useExisting: AuthenticationService },
        { provide: ErrorHandler, useClass: ErrorHandlerService },
        { provide: MAT_DATE_LOCALE, useValue: enAU}
    ],
};
